import {
    FormControl,
    FormLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { useContext, useState } from "react";

import { LanguageContext } from "src/contexts/language";
import { MapContext } from "src/contexts/map";
import { Type_Props_Input } from "src/types/input";
import { handleInputBlur } from "src/utils/element";

const BasicSelect = ({ data }: Type_Props_Input) => {
    const { language } = useContext(LanguageContext);
    const { newElement, updateNewElement } = useContext(MapContext);
    const [selectedValue, setSelectedValue] = useState(
        (newElement?.data?.find((input) => input.input_id === data.id)
            ?.value as string) || "",
    );

    const handleChange = (event: SelectChangeEvent<string>) => {
        setSelectedValue(event.target.value as string);
    };

    if (!data) return null;

    return (
        <FormControl
            fullWidth
            onBlur={() =>
                handleInputBlur({
                    data,
                    selectedValue,
                    newElement,
                    updateNewElement,
                })
            }
        >
            <FormLabel>{data.title[language]}</FormLabel>
            <Select value={selectedValue} onChange={handleChange}>
                {data.options?.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default BasicSelect;
